import { render } from "./PaymentIcon.vue?vue&type=template&id=08797b9e"
import script from "./PaymentIcon.vue?vue&type=script&lang=js"
export * from "./PaymentIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__